import { Component, Input } from '@angular/core';
import { FormGroup, ValidationErrors, NgForm } from '@angular/forms';
import { Registration } from '../../interfaces';
import { MultiSelectElement } from '../../models/multi-select-element';
import * as _ from 'lodash';

@Component({
  selector: 'app-multiselect-control',
  templateUrl: './multiselect-control.component.html',
  styleUrls: ['./multiselect-control.component.less']
})
export class MultiselectControlComponent {
    @Input() public question: Registration.Form.IMultiSelectElement;
  @Input() public formGroup: FormGroup;
  @Input() public form: NgForm;

  public get valid(): boolean {
    return this.formGroup.controls[this.question.inputKey].valid;
  }

  public get submitted(): boolean {
    return this.form.submitted;
  }

  public get required(): boolean {
    const attr = this.getAttribute('required');
    return attr && attr === 'required';
  }

  public get placeholder(): string {
    const attr = this.getAttribute('placeholder');
    return attr || '';
  }

  public get pattern(): string {
    const attr = this.getAttribute('pattern');
    return attr || '';
  }

  private getAttribute(name: string): string {
    let result;
    this.question.attributes.forEach((item) => {
      if (item.name === name) {
        result = item.value;
      }
    });

    return result;
    }


  public setMultiselect(): void {
    if (this.question.inputType === 'multiselect') {
      const values: string[] = [];
      const multiSelectElement = this.question as MultiSelectElement;
      _.each(multiSelectElement.controls, (item) => {
        const index = multiSelectElement.controls.indexOf(item);
        if (item.value === true) {
          values.push(multiSelectElement.options[index].value);
        }
      });
      const value = values.join(',');
      this.question.control.setValue(value);
    }
  }
}
